import {
  List,
  Datagrid,
  TextField,
  EmailField,
  EditButton,
  Filter,
  TextInput,
  FunctionField,
  Button,
  NumberField,
  DateInput,
} from "react-admin";
import { Link } from "react-router-dom";
import { formatDateToFrenshFormat } from "../utils/formatDateToFrenshFormat";

const ProviderFilter: React.FC = (props) => (
  <Filter {...props}>
    <TextInput label="Code interne" source="internalCode" alwaysOn />
    <TextInput label="Nom du prestataire" source="name" alwaysOn />
    <TextInput label="Adress" source="address" alwaysOn />
    <TextInput label="Courriel" source="email" alwaysOn />
    <DateInput
      source="startDateScheduled"
      alwaysOn
      label="D. début (dernier RDV)"
    />
    <DateInput
      source="endDateLastScheduled"
      alwaysOn
      label="D. fin (dernier RDV)"
    />
    <DateInput
      source="startDateExecution"
      alwaysOn
      label="D. début (dernier exécution RDV)"
    />
    <DateInput
      source="endDateLastExecution"
      alwaysOn
      label="D. fin (dernier exécution RDV)"
    />
  </Filter>
);

export const ProviderList = () => (
  <List
    resource="providers"
    filters={<ProviderFilter />}
    sort={{ field: "createdAt", order: "DESC" }}
  >
    <Datagrid rowClick="edit">
      <TextField source="internalCode" label="Code interne" />
      <TextField source="name" label="Nom" />
      <TextField source="address" label="Adresse" />
      <EmailField source="email" label="Courriel" />
      <NumberField
        source="fullBinsCount"
        label="Caisses pleines"
        textAlign="center"
      />
      <NumberField
        source="emptyBinsCount"
        label="Caisses vides"
        textAlign="center"
      />
      <FunctionField
        source="latestRdvScheduledDate"
        label="Derniere date RDV"
        render={(record: any) =>
          record.latestRdvScheduledDate
            ? formatDateToFrenshFormat(record.latestRdvScheduledDate, true)
            : "-"
        }
      />
      <FunctionField
        source="latestRdvExecutionDate"
        label="Derniere date d'execution RDV"
        render={(record: any) =>
          record.latestRdvExecutionDate
            ? formatDateToFrenshFormat(record.latestRdvExecutionDate, true)
            : ""
        }
      />
      <EditButton label="Modifier" />
      <FunctionField
        label="Inventaire"
        render={(record) => (
          <Button
            component={Link}
            to={`/provider-inventory/details/${record.id}`}
            variant="outlined"
            size="small"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            Voir
          </Button>
        )}
      />
    </Datagrid>
  </List>
);
